import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ResidencyResidentsFilter from './index.vue';

const MOUNT_SELECTOR = '[data-residency-residents-filter-mount]';

let filterApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initResidencyResidentsFilter(root?: ParentNode): void {
  const mountEl = root
    ? root.querySelector<HTMLElement>(MOUNT_SELECTOR)
    : document.querySelector<HTMLElement>(MOUNT_SELECTOR);

  if (!mountEl) {
    return;
  }

  if (filterApp && currentMountEl) {
    filterApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ResidencyResidentsFilter);
  app.use(AntDesignVue);
  app.mount(mountEl);

  filterApp = app;
  currentMountEl = mountEl;
}
